import styled from "@emotion/styled";
import {colors, Flex} from "../../ui";

export const ValorS = styled.div`
    width:100%;
    flex:${props => props.flex};
    
    .listenClick{
        position:relative;
        padding:5px 8px;
        cursor:${props=> props.active ? "initial" : "pointer"};
       
        .circle{
            position:absolute;
            width:20px;
            height:20px;
            padding:2px;
            background:white;
            border-radius:10px;
            border:2px solid white;
            display:block;
            top:50%;
            left:0;
            transform:translateY(-10px);
            z-index:2;
            
            
            .point{
                height:100%;
                width:100%;
                border-radius:50%;
                border:2px solid ${props=> props.active ? colors.btn :"#cbcbcb"};
                background: ${props => props.selected};
            }
        }
         .text{
            border:${props=> props.active ? "2px solid " + colors.btn : "2px dotted #cbcbcb"};
            border-radius:6px;
            padding:3px 5px 3px 18px;
            text-align:left;
            background:${props=> props.active ? "#f1f1f1" : "transparent"};
            
            b{
                font-size:13px;
                position:relative;
                z-index:3;
            }
            input{
                height:100%;
                padding-top:20px;
                margin-top:-20px;
                width:100%;
                
                &:focus{
                    outline:none;
                    box-shadow:none;
                }
            } 
        }
        
        &:hover{
            .text{
                border: 2px solid ${props=> props.active ? colors.btn : "#cbcbcb"};
            }
        }
    }
`;


export const Whitecont  = styled(Flex)`
    border-radius:8px;
    background:white;
    overflow:hidden;
`;


export const BtnLine  = styled.button`
    border-radius:${props=> props.br};
    border:2px solid ${props=> props.brd};
    padding:10px;
    text-align:center;
    
    &:focus{
        outline:none;
    }
`;

export const MainCheck  = styled(Flex)`
    border-right:1px solid #cbcbcb;
`;

export const CustomInput  = styled.div`
   width:auto;
   flex:${props=> props.flex};
    
  
   input{
    border:2px solid #cbcbcb;
    height:50px;
    border-radius:6px;
    padding:.75em;
    font-size:18px;
    cursor:pointer;
      
    &:focus{
        border:2px solid ${colors.btn};    
        outline:none;
    }
   }    
   
`;
